/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Active
 *
 * 2 = Completed
 */
export enum WorkshopCheckOutStatusEnum {
  Active = 1,
  Completed = 2,
}
